export default __webpack_public_path__ + "static/media/development_plan.d26fdd0a.svg";